import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgClass, NgIf, NgStyle } from "@angular/common";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { SharedModule } from "../../modules/shared/shared.module";
import { CommonService } from "../../services/common-service.service";
import { FileEntity } from "../../models/common-model.interface";

@Component({
  selector: "app-file-upload",
  standalone: true,
  imports: [
    NgStyle,
    NgClass,
    SharedModule,
    SvgIconComponent
  ],
  templateUrl: "./file-upload.component.html",
  styleUrl: "./file-upload.component.scss"
})
export class FileUploadComponent {
  isDragging = false;
  error: { hasError: boolean, errorMsg: string } = { hasError: false, errorMsg: "" };

  @Input() title: string = "Click to upload or drag and drop";
  @Input() files: FileEntity[] = [];
  @Input() allowedFileTypes: string[] = [];
  @Input() multiFileUpload: boolean = false;
  @Input() disabled: boolean = false;

  @Output() filesChange = new EventEmitter<FileEntity[]>();

  constructor(private commonService: CommonService) {
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files) {
      this.handleFiles(Array.from(files));
    }
  }

  onFileSelected(event: Event): void {
    const element = event.target as HTMLInputElement;
    const files = element.files;
    if (files) {
      this.handleFiles(Array.from(files));
    }
  }

  private handleFiles(files: File[]): void {
    if (!files.length)
      return;
    console.log("Uploaded files:", files);
    for (const file of files) {
      const fileType = file?.type || this.getFileType(file);
      if (this.allowedFileTypes.length && !this.allowedFileTypes.includes(fileType)) {
        this.setError(true, "Invalid file type");
        return;
      }
      this.error.hasError = false;
      if (!this.files.some(f => f.file.name === file.name)) {
        const newEntity: FileEntity = { file: file };
        this.files.push(newEntity);
      }
    }
    this.filesChange.emit(this.files);
  }

  setError(hasError: boolean, errorMsg: string): void {
    this.error = { hasError, errorMsg };
  }

  getFileTypeColor(file: File): string {
    const type = this.getFileType(file);
    switch (type) {
      case "CSV":
        return "rgba(76, 163, 13, 1)"; // Green
      case "PNG":
      case "JPG":
      case "JPEG":
        return "rgba(255, 105, 46, 1)"; // Orange
      case "PDF":
        return "rgba(227, 27, 84, 1)"; // Red
      default:
        return "rgba(16, 98, 185, 1)"; // Default Gray
    }
  }

  getFileType(file: File): string {
    if (!file) return "";
    console.log("file?.type: ", file?.type);
    const parts = file?.type.split("/");
    return parts.length > 1 ? parts[1].toUpperCase() : file?.name?.split(".")[1].toString().toUpperCase();
  }

  removeFileAdded() {
    this.files.length = 0;
    this.filesChange.emit(this.files);
  }

  removeFileAddedForMulti(index: number) {
    this.files.splice(index, 1);
    this.filesChange.emit(this.files);
  }
}
